export const ModalEvent = {
  modal_show: 'modal_shown',
  modal_cta_clicked: 'modal_cta_clicked',
  modal_closed: 'modal_closed',
} as const;